/* CONSTANTS */
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

/* PUBSUB */
let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

/* CUSTOM */
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.header-wrapper.is-light')) {
        document.querySelector('.header-wrapper.is-light').addEventListener('mouseover', function (event) {
            this.classList.add('hovered');
            this.classList.remove('is-light');
        })
    }
    if (document.querySelector('.header-wrapper[data-overlay="true"]')) {
        document.querySelector('.header-wrapper[data-overlay="true"]').addEventListener('mouseout', function (event) {
            this.classList.remove('hovered');
            this.classList.add('is-light');
        })
    }
});


document.querySelector('.mobile-menu__icon').addEventListener('click', () => {
    if (document.querySelector('.mobile-menu__icon').classList.contains('is-open')) {
        document.querySelector('#mobile-menu__nav').style.display = 'none';
        document.querySelector('#mobile-menu__nav').style.opacity = 0;
        if (document.querySelector('.header-wrapper[data-overlay="true"]')) {
            document.querySelector('.header-wrapper[data-overlay="true"]').classList.toggle('hovered');
            document.querySelector('.header-wrapper[data-overlay="true"]').classList.toggle('is-light');
        }
    } else {
        document.querySelector('#mobile-menu__nav').style.display = 'flex';
        document.querySelector('#mobile-menu__nav').style.opacity = 1;
    }
    document.querySelector('.mobile-menu__icon').classList.toggle('is-closed')
    document.querySelector('.mobile-menu__icon').classList.toggle('is-open')

})

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mobile-menu-icon-wrap').forEach(trigger => {
        trigger.addEventListener('click', function () {
            this.x = ((this.x || 0) + 1) % 2;
            if (this.x) {
                document.querySelectorAll('.nav').forEach(target => target.classList.add('hovered'));
                // document.querySelectorAll('body').forEach(target => target.classList.add('no-scroll'));
            }
            else {
                document.querySelectorAll('.nav').forEach(target => target.classList.remove('hovered'));
                // document.querySelectorAll('body').forEach(target => target.classList.remove('no-scroll'));
            }
        });
    });
});


/* GLOBAL */
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');
        this.summary = this.mainDetailsToggle.querySelector('summary');
        this.content = this.summary.nextElementSibling;

        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.summary.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
        e.preventDefault();
        this.mainDetailsToggle.style.overflow = 'hidden';
        if (this.isClosing || !this.mainDetailsToggle.open) {
            this.open();
        } else if (this.isExpanding || this.mainDetailsToggle.open) {
            this.shrink();
        }
    }

    shrink() {
        this.isClosing = true;
        const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.mainDetailsToggle.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
        this.mainDetailsToggle.style.height = `${this.mainDetailsToggle.offsetHeight}px`;
        this.mainDetailsToggle.open = true;
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        this.isExpanding = true;
        const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        if (this.animation) {
            this.animation.cancel();
        }
        this.animation = this.mainDetailsToggle.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 400,
            easing: 'ease-out'
        });
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
        this.mainDetailsToggle.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.mainDetailsToggle.style.height = this.mainDetailsToggle.style.overflow = '';
    }
}
customElements.define('details-disclosure', DetailsDisclosure);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    /*initDeferredMedia() {
        let slideIndex = window.productSwiper.realIndex;
        let currentSlide = window.productSwiper.slides[slideIndex]
        if (!currentSlide.querySelector('.deferred-media')) return;
        let deferredMedia = currentSlide.querySelector('.deferred-media');
        console.log('deferredMedia', deferredMedia)
        deferredMedia.removeAttribute('loaded');
    }*/

    loadContent(focus = true) {
        console.log('CLICK POSTER')
        window.pauseAllMedia();
        if (this.getAttribute('loaded')) {
            console.log('LOADED')

        }
        if (!this.getAttribute('loaded')) {
            console.log('NOT LOADED')
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }

    playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
    }
}
customElements.define('deferred-media', DeferredMedia);


class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
        }
        this.input.setAttribute('value', value);
    }
}
customElements.define('quantity-input', QuantityInput);


function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}
